import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import type { HealthLevel } from '../types';
import { healthLabel } from '../utils';

interface HealthBadgeProps {
  level: HealthLevel;
  className?: string;
}

const HealthBadge: React.FC<HealthBadgeProps> = ({ level, className }) => {
  const { colors } = useTheme();
  const tone =
    level === 'ok'
      ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300'
      : level === 'warning'
        ? 'bg-amber-50 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300'
        : level === 'error'
          ? 'bg-rose-50 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300'
          : level === 'info'
            ? 'bg-sky-50 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300'
            : cn(colors.surfaceHover, colors.textMuted);

  return (
    <span className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold', tone, className)}>
      {healthLabel(level)}
    </span>
  );
};

export default HealthBadge;
